
import { Link, isRouteErrorResponse, useRouteError } from 'react-router';

export default function RouteError() {

	const error = useRouteError();
	const notFound = isRouteErrorResponse(error) && error.status === 404;

	console.log(error);

	return (
		<div className="flex min-h-dvh flex-col items-center justify-center bg-slate-50 px-4 text-center text-slate-900 dark:bg-[#0c0d0f] dark:text-white">
			<h1 className="text-6xl font-bold tracking-tight">
				{notFound ? '404' : 'Oops!'}
			</h1>

			<h2 className="mt-4 text-xl font-semibold">
				{notFound ? 'Resursa nu a fost găsită' : 'A apărut o eroare'}
			</h2>

			<p className="mt-2 max-w-md text-sm text-slate-500 dark:text-slate-400">
				{notFound
					? 'Resursa solicitată nu există sau nu mai este disponibilă.'
					: 'Nu am putut încărca această pagină. Te rugăm să încerci din nou.'}
			</p>

			<div className="mt-6 flex items-center gap-3">
				<Link to="/" className="rounded-lg bg-brand-500 px-5 py-2.5 text-sm font-semibold text-black hover:bg-brand-400">
					Dashboard
				</Link>

				<button type="button" onClick={() => window.location.reload()} className="rounded-lg border border-slate-200 px-5 py-2.5 text-sm font-medium hover:bg-slate-100 dark:border-white/10 dark:hover:bg-white/5">
					Reîncearcă
				</button>
			</div>
		</div>
	);
}